const STORAGE_PREFIX = 'pod:bulk-upload-run:'

export function folderKeyFromFiles(files: File[]): string {
  return files
    .map((f) => f.name)
    .sort()
    .join('|')
    .slice(0, 8000)
}

export function docNoFromFileName(fileName: string): string {
  return fileName.split('.').slice(0, -1).join('.')
}

export function groupFilesByDocumentNo(files: File[]): Map<string, File[]> {
  const map = new Map<string, File[]>()
  for (const file of files) {
    const docNo = docNoFromFileName(file.name)
    if (!map.has(docNo)) map.set(docNo, [])
    map.get(docNo)!.push(file)
  }
  return map
}

export function loadPersistedBatchId(documentType: string, folderKey: string): string | null {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${documentType}`)
    if (!raw) return null
    const parsed = JSON.parse(raw) as { batchId?: string; folderKey?: string }
    if (parsed.folderKey === folderKey && parsed.batchId) return parsed.batchId
  } catch {
    /* ignore */
  }
  return null
}

export function persistBatchRun(documentType: string, folderKey: string, batchId: string): void {
  try {
    sessionStorage.setItem(
      `${STORAGE_PREFIX}${documentType}`,
      JSON.stringify({ batchId, folderKey, updatedAt: Date.now() })
    )
  } catch {
    /* ignore */
  }
}

export function clearPersistedBatchRun(documentType: string): void {
  try {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${documentType}`)
  } catch {
    /* ignore */
  }
}

export type BulkUploadResumeFileState = {
  state: 'new' | 'done' | 'retry'
  skip: boolean
  needsUpload?: boolean
  status?: string
  outcome?: string | null
  documentNo?: string
  batchId?: string | null
  fileUrl?: string | null
}

export type BulkUploadResumeStatus = {
  files: Record<string, BulkUploadResumeFileState>
  suggestedBatchId: string | null
  counts: { done: number; retry: number; new: number }
}

export { mergeResumeStatuses } from './bulkUploadResumeMerge'
export { fetchBulkUploadResumeChunk as fetchBulkUploadResumeStatus } from './bulkUploadResumeFetch'
